<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to=''>会员中心</router-link></li>
                <li class="currentNode"><a>修改密码</a></li>
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>修改密码</h3>
                    <el-form label-width="90px" :model="form" :rules="rules" ref="ruleForm" class="form" size="small">
                        <!-- <el-form-item label="用户名"  prop="loginName">
                            <el-input v-model="form.loginName"></el-input>
                        </el-form-item> -->
                        <el-form-item label="原密码"  prop="oldPass">
                            <el-input v-model="form.oldPass"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码" prop="newPass">
                            <el-input v-model="form.newPass" type="password"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="newPassAgain">
                            <el-input v-model="form.newPassAgain" type="password"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="onSubmit" class="submitBtn">修改密码</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    updatePwd,
    getAccountModel
} from '@services/tokenService.js';
import rulesPattern from '@/assets/utils/rulesPattern.js';
import { getCookie } from '@/assets/utils/cookie.js'
export default {
    name:'',
    components: { PersonCenterMenu },
    data() {
        return {
            form: {
                // loginName: '',
                oldPass: '',
                newPass: '',
                newPassAgain: '',
                type: '',
            },
            rules: {
                // loginName: [
                //     { required: true, message: '请输入用户名', trigger: 'blur' },
                // ],
                oldPass: [
                    { required: true, message: '请输入原密码', trigger: 'blur' },
                ],
                newPass: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { pattern: rulesPattern.password, message: '6-20位密码，大小写加数字组合', trigger: 'blur' }
                ],
                newPassAgain: [
                    { required: true, message: '请再一次输入新密码', trigger: 'blur' },
                    { validator: this.validConfirmPass, message: '两次输入密码不一致', trigger: 'blur' }
                ],

            }
        }
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
        loginName() {
            return this.$store.state.permission.loginName;
        }
    },
    created() {
        if (this.accountId === '') {
            this.$router.push(
                {
                    path: '/layout/login',
                }
            );
        }
        // this.getAccountModel();
    },
    methods: {
        getAccountModel() {
            let param = {
                accountid: getCookie('accountId'),
            };
            getAccountModel(param).then(res => {
                console.log(res)
                if (res.Code == 1) {
                   
                } else {
                    this.$message.error("获取用户信息失败");
                }
            })
        },
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.updatePwd();
                } else {
                    return false;
                }
            });
        },
        updatePwd() {
            let param = {
                accountid: this.accountId,
                loginname: this.loginName,
                oldPwd: this.form.oldPass,
                newPwd: this.form.newPass,
                RePwd: this.form.newPassAgain,
            };
            let url = "?";
            for(let key in param) {
                url += (key + '=' + param[key] + '&');
            };
            url = url.slice(0, -1)
            let params = {
                url: url
            };
            updatePwd(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.$message.success("密码修改成功，请您重新登录！");
                    this.$router.push(
                        {
                            path: '/layout/login',
                            query: {
                                type: 'exit'
                            }
                        }
                    );
                    
                } else {
                    this.$message.error(res.Message);
                }

            })
        },
        /**
         * 验证确认密码
         */
        validConfirmPass(rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入新密码'));
            } else if (value !== this.form.newPass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        }
    },
}
</script>

<style scoped>
.page-content {
    padding: 30px;
    min-height: 750px;
}
.page-content h3{
    text-align:center;
    margin-bottom: 20px;
}
.form{
    width: 450px;
    margin: 0 auto;
}
.vertical-nav li a.active {
    border-left: none;
}
.el-button:focus, .el-button:hover {
    color: #fff;
    border-color: #005091;
    background-color: #005091;
}

</style>